export const phoneNumber = '051 801 820'
export const rawPhoneNumber = '0038651801820'
